/** @jsxImportSource @emotion/react */
import React, { useEffect, useState, useContext,useRef } from 'react'
import { Button, Grid, Typography, useTheme, Dialog, DialogTitle, DialogContent } from "@mui/material";
import PermissionIcon from '@mui/icons-material/VideocamOff';
import FullScreenLoader from '../../FullScreenLoader';
import { Il8nContext } from '../../../Helper/i18n';
import { insertHyphens } from '../../../Helper/Functions';
import axios from 'axios';
import config from '../../../config';
import '../UploadVideo/style'
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { css, keyframes } from '@emotion/react';
import Webcam from 'react-webcam';

function CaptureImg({ recordImgInstruction, uploadImageProof,...props }) {
  const [state, setState] = useState({ permission: false, locationPermission: false })
  const { permission, locationPermission } = state;
  const localeText = useContext(Il8nContext)

  const [errorMessage, setErrorMessage] = useState('');
  const [showBlinking, setShowBlinking] = useState(true);
  const [timeLeft, setTimeLeft] = useState(30); // 30 seconds timer
  const [speechDetected, setSpeechDetected] = useState(false);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);
  const recognitionRef = useRef(null);
  const videoRef = useRef(null);
  const webcamRef = useRef(null);
  const [showFailPopup, setShowFailPopup] = useState({
    "showPopup": false,
    "showPopupMessage": ""
  })
  const [showFailedMsgDiv, setShowFailedMsgDiv] = useState(false); // error show when imganalysis fail
  const [showFailedMsgMainDiv, setShowFailedMsgMainDiv] = useState(false);

  const startTimer = () => {
    setSpeechDetected(false);
    startSpeechRecognition();
    setTimeLeft(30);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          stopRecognition();
          setShowBlinking(false);
          if (!speechDetected) {
            setShowFailPopup({ showPopup: true, showPopupMessage: 'No speech was detected. Please try again.' });
            stopRecognition();
        } else {
          setErrorMessage(
            'Number shown on screen does not match with number said by you, kindly speak loud and clear numbers one by one.'
          );
        }
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
      // Request media device (microphone and video) permissions
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(successCallback)
        .catch(errorCallback);

      // Request geolocation permission
      navigator.geolocation.getCurrentPosition(successLocationCallback, showLocationError);
    }, []);

 useEffect(() => {
    if (recordImgInstruction?.uniqueCode && permission && locationPermission) {
      startTimer();
    }

    return () => {
      clearInterval(timerRef.current);
      stopRecognition();
    };
  }, [recordImgInstruction?.uniqueCode,permission,locationPermission]);

const startSpeechRecognition = () => {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

  if (typeof SpeechRecognition === 'undefined') {
    setErrorMessage('SpeechRecognition API is not supported in this browser.');
    return;
  }

  const recognition = new SpeechRecognition();
  recognitionRef.current = recognition;
  recognition.lang = 'en-US';
  recognition.interimResults = true;
  recognition.continuous = true;

  recognition.onresult = (event) => {
    let transcript = '';
    for (const result of event.results) {
        transcript += result[0].transcript;
    }
    const spokenNumbers = transcript.replace(/\D/g, '');
    const targetNumber = String(recordImgInstruction.uniqueCode);
    if (spokenNumbers.includes(targetNumber)) {
    clearInterval(timerRef.current);
    stopRecognition();
    setSpeechDetected(true);
    setShowBlinking(false);
    setErrorMessage('');
  }
};

recognition.onerror = (event) => {
    console.error('Speech recognition error:', event.error);
    let message = `Error: ${event.error}. `;
    if (event.error == 'not-allowed') {
        message = 'Microphone access denied or blocked. Please enable it in your browser settings and ensure you are on HTTPS.';
      } else if (event.error == 'no-speech') {
        message = 'No speech was detected. Please try again.';
      } else if (event.error == 'network') {
        message = 'Network connection issue. Please check your internet connection.';
      } else if (event.error == 'bad-grammar') {
        message = "Grammar error detected.";
      } else if (event.error == 'aborted') {
        message = 'Recognition aborted.';
      }
    setShowFailPopup({ showPopup: true, showPopupMessage: message });
    stopRecognition();
};

  recognition.start();
};

  const stopRecognition = () => {
    recognitionRef.current?.stop();
  };

  const blink = keyframes`50% { visibility: hidden; }`;
  const theme = useTheme()
  const classes = {
    video: {
      width: '100%',
      height: '100%',
      borderRadius: 'inherit',
    },
    videoRecord: {
      width: '100%',
      height: '100%',
      borderRadius: 'inherit',
      transform: 'rotateY(180deg)'
    },
    marginTop: {
      marginTop: theme.spacing(1),
    },
    recordButton: {
      padding: "10px 20px",
    },
    button: {
      padding: "5px 15px",
      marginRight: theme.spacing(2),
      boxShadow: '0px 6px 8px -6px #f540405c'
    },
    bottomButtonGrid: {
      marginTop: "20px"
    },
    marginButtonTop: {
      marginTop: "15px",
      marginRight: "20px"
    },
    leftIcon: {
      marginRight: theme.spacing(1),
      marginLeft: '24px'
    },
    error: {
      display: 'flex'
    },
    buttonResp: {
      padding: "10px 40px"
    },
    stopButton: {
      textTransform: "none",
      position: "absolute",
      top: 0,
      right: 0,
      color: "#fff"
    },
    videoStartedText: {
      fontWeight: "bold",
      fontSize:"18px",
      textAlign: "center",
      display: "block"
    },
   blinking: css`
    animation: ${blink} 1s step-end infinite;
  `,
    videoTextWrap: {
      display: "flex",
      justifyContent: "start",
    },
    failMessage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
  }
  }

  var constraints = {
    audio: true,
    video: {
      facingMode: 'user', // Or 'environment'
      width: { ideal: 640 },   // Request an ideal width of 640 pixels
      height: { ideal: 480 },  // Request an ideal height of 480 pixels
      frameRate: { ideal: 10, max: 15 }
    }
  };

  // Callback for successful geolocation
  const successLocationCallback = (position) => {
    setState(prevState => ({ ...prevState, locationPermission: true }));
  };

  // Error handler for geolocation
  const showLocationError = (error) => {
    setState(prevState => ({ ...prevState, locationPermission: false }));
  };

  const successCallback = (stream) => {
  window.stream = stream;
  if (videoRef.current) {
    videoRef.current.srcObject = stream;
  }
  setState(prev => ({ ...prev, permission: true }));
};

  // Error handler for media devices (microphone and video)
  const errorCallback = (error) => {
    setState(prevState => ({ ...prevState, permission: false }));
  };

  const handleImageCapture = async () => {
    setLoading(true); //FullScreenLoader

    const video = webcamRef.current?.video;
    if (!video) {
    setLoading(false);
    setShowFailPopup({ showPopup: true, showPopupMessage: "Webcam not available." });
    return;
    }
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataURL = canvas.toDataURL('image/jpeg');
    const imageSrc = webcamRef.current.getScreenshot();

    if (!imageSrc) {
      setLoading(false);
      setShowFailPopup({
        showPopup: true,
        showPopupMessage: "Failed to capture image. Please try again.",
      });
      return;
    }
    const base64Image = imageSrc.split("base64,")[1];

    const payload = [{
      UID: '',
      latitude: props.lat,
      longitude: props.long,
      file: base64Image,
      mimeType: "image/jpeg"
    }];

  await axios.post(process.env.REACT_APP_AARAMBHAH_URL + config.uploadImageAnalysis, payload)
  .then(resp => {
  const analysis = resp?.imageAnalysis;
  if ((analysis?.status === true && analysis?.isForceProceed === false) || (analysis?.status === false && analysis?.isForceProceed === true)) {
    if (analysis?.isForceProceed) {
      setShowFailedMsgDiv(true);
      return;
    }

    saveImage(imageDataURL); //send image to upload
  } else {
    setLoading(false);
    setShowFailPopup({ showPopup: true, showPopupMessage: analysis?.message || ["Verification failed"] });
  }
  if (resp.error) {
    setLoading(false);
    setShowFailedMsgMainDiv(true)
  }
  })
  .catch(err => {
      setShowFailPopup({ showPopup: true, showPopupMessage: err.message || "Something went wrong. Please try again." });
      setLoading(false);
  });
  }

  const saveImage = async (imgData) => {
      const base64Data = imgData.split("base64,")[1];

      if (imgData) {
        setLoading(false);
        uploadImageProof([base64Data], 0, "", "", props.lat, props.long, true, "", "", true)
      } else{
        setLoading(false);
        setShowFailPopup({ showPopup: true, showPopupMessage: "Something went wrong. Please try again." });
      }
  };

  const handleTimerRestart = () =>{
    setShowFailPopup({ showPopup: false, showPopupMessage: "" });
    setLoading(false);
    setSpeechDetected(false);
    setErrorMessage('');
    setShowBlinking(true);
    startTimer();
  }

return (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 9999 }}>
        <IconButton onClick={props.onClose} style={{ background: '#fff' }}>
          <CloseIcon />
        </IconButton>
      </div>
    {showFailedMsgDiv ? (
      <div id="IPVfailedMsg" className="message" css={classes.failMessage}>
        <h2>Your online IPV verification failed</h2>
        <p>
          Please contact <a href="mailto:kychelpdesk@tradebulls.in">kychelpdesk@tradebulls.in</a> /
          <a href="mailto:enterprise.support@tradebulls.in">enterprise.support@tradebulls.in</a>.
        </p>
      </div>
    ) : (
      <>
        {(!permission && !locationPermission) ? (
          <h3 css={classes.error}><PermissionIcon css={classes.leftIcon} />{localeText?.noPermissions}</h3>
        ) : (!permission) ? (
          <h3 css={classes.error}><PermissionIcon css={classes.leftIcon} />{localeText?.uploadPermission}</h3>
        ) : (!locationPermission) ? (
          <h3 css={classes.error}><PermissionIcon css={classes.leftIcon} />{localeText?.locationAccess}</h3>
        ) : (
          <>
            {showFailPopup.showPopup && (
              <Dialog open={showFailPopup.showPopup} maxWidth="md" fullWidth>
                <DialogTitle>
                  <Grid container direction="column" alignItems="center" justifyContent="center">
                    <Grid item>
                      <Typography variant="h6" style={{ fontWeight: "bold", textAlign: "center", color: "red" }}>
                        Image verification failed, please try again!
                      </Typography>
                    </Grid>
                  </Grid>
                </DialogTitle>
                <DialogContent style={{ textAlign: "center", margin: "0px 30px" }}>
                  <Grid container direction="column" alignItems="flex-start">
                <Typography variant="body1" style={{ textAlign: 'left', fontSize: '18px', color: 'black', fontWeight: 'normal', marginTop: "1rem" }}>
                  {Array.isArray(showFailPopup.showPopupMessage) ? (
                    <ul style={{ paddingLeft: '1.5rem', margin: 0, listStyleType: 'disc' }}>
                      {showFailPopup.showPopupMessage.map((msg, idx) => (
                        <li key={idx} style={{ marginBottom: '0.5rem' }}>
                          {msg}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    showFailPopup.showPopupMessage
                  )}
                </Typography>
                  </Grid>
                  <Grid item display="flex" justifyContent="center">
                    <Button variant="contained" color="primary" style={{ textTransform: "none", marginTop: "30px", textAlign: "center" }} onClick={handleTimerRestart}>
                      OK
                    </Button>
                  </Grid>
                </DialogContent>
              </Dialog>
            )}

          {/* Webcam container */}
          <div className="video-container" style={{ marginTop: "4rem" }}>
            <Webcam
              audio={false}
              ref={webcamRef}
              width="100%"
              videoConstraints={{
                facingMode: 'user', // Or 'environment'
                width: 640, // Ideal width of 640 pixels
                height: 480, // Ideal height of 480 pixels
                frameRate: { ideal: 10, max: 15 }
              }}
            />
          </div>

         {timeLeft !== 0 && !speechDetected && (
          <span css={classes.videoStartedText}>
            {localeText?.listening}
            {showBlinking && <span css={classes.blinking}>{localeText?.blinkingText}</span>}
          </span>
        )}

            {recordImgInstruction?.uniqueCode && (
              <div className='digitCode'>
                <p>
                  <img src="images/speak-aloud.svg" width="25" height="25" />
                  <span>{localeText?.VerifyUniqueCodeText}</span>
                </p>
                <div className='verificationCode'>{insertHyphens(recordImgInstruction?.uniqueCode)}</div>
              </div>
            )}

            {errorMessage && (
              <div className="error_Message" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',padding: '10px' }}>
                  <Typography variant='h6'>{errorMessage}</Typography>
              </div>
            )}

            {showFailedMsgMainDiv && <div id="failedMsg" style={{ display: 'none', textAlign: 'center' }}>
              <img src="/images/noaccess.svg" />
              <h3>You have exceeded the maximum allowed attempts (10) for Video In-Person Verification (IPV)</h3>
              <h3>
                Kindly contact KYC Team <a href="mailto:kychelpdesk@tradebulls.in">(kychelpdesk@tradebulls.in)</a> or Enterprise Support Team <a href="mailto:enterprise.support@tradebulls.in">(enterprise.support@tradebulls.in)</a>.
              </h3>
            </div>}

            {/* Capture Button */ }
            {speechDetected && <div style={{ textAlign: 'center' }}>
              <Button
                css={`${classes.recordButton} ${classes.marginTop} ${classes.marginButtonTop}`}
                variant="contained"
                color="primary"
                onClick={handleImageCapture}
              >
                {localeText?.uploadCapture}
              </Button>
            </div>}

          </>
        )}
        <div css={classes.videoTextWrap}>
          {loading &&
            <>
              <FullScreenLoader width="100%" height="100%" />
            </>
          }
        </div>
      </>
    )}
  </div>
);
}

export default CaptureImg
